import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

// Lazy loading presentation page sections
import InformationHome from "pages/Servicii/ServiciiSpeciale/CuratenieGaleriiComerciale/sections/sections/InformationHome";
import TestimonialsHome from "pages/Servicii/ServiciiSpeciale/CuratenieGaleriiComerciale/sections/sections/TestimonialsHome";
import HeroSection from "pages/Servicii/ServiciiSpeciale/CuratenieGaleriiComerciale/sections/sections/HeroSection";
import ArticleContent from "pages/Servicii/ServiciiSpeciale/CuratenieGaleriiComerciale/sections/sections/ArticleContent";

function CuratenieGaleriiComerciale() {
    return (
        <>
            <Helmet>
                <title>Curățenie Galerii Comerciale &amp; Showroom-uri | Doral Cleaning</title>
                <meta
                    name="description"
                    content="Curățenie profesională pentru galerii comerciale, showroom-uri și spații de prezentare cu trafic intens."
                />
                <link
                    rel="canonical"
                    href="https://doral-cleaning.ro/curatenie-galerii-comerciale/"
                />
                <script type="application/ld+json">
                    {`{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Cât de des ar trebui să veniți la noi în locație?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Depinde de trafic, de suprafață și de tipul activității. Într-un spațiu cu rulaj mare, de multe ori este nevoie de întreținere zilnică, iar în anumite perioade și de verificări suplimentare în zonele cele mai expuse."
      }
    },
    {
      "@type": "Question",
      "name": "Puteți veni dimineața devreme sau după ce închidem?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Da. Intervențiile pot fi programate înainte de deschidere, după închidere sau în intervalele în care fluxul de clienți este mai redus."
      }
    },
    {
      "@type": "Question",
      "name": "Spălați și vitrinele?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Da. Putem include și vitrinele, geamurile și alte suprafețe vitrate, fie recurent, fie separat, în funcție de nevoile locației."
      }
    },
    {
      "@type": "Question",
      "name": "Cum calculați prețul pentru un astfel de serviciu?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Prețul nu se ghicește din telefon. Contează cât de mare este spațiul, ce pardoseli are, cât trafic intră zilnic și ce zone trebuie urmărite mai des. După ce vedem locația, putem trimite o oferta de pret."
      }
    },
    {
      "@type": "Question",
      "name": "Folosiți produse sigure pentru clienți și pentru echipa noastră?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Da. Alegem soluțiile în funcție de tipul suprafețelor și de specificul locației, astfel încât intervenția să fie eficientă și potrivită pentru un mediu comercial folosit zilnic."
      }
    },
    {
      "@type": "Question",
      "name": "Puteți prelua și mai multe locații, nu doar una?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Da. Putem organiza intervențiile pentru o singură unitate sau pentru mai multe puncte de lucru, cu plan de lucru clar și adaptări făcute separat pentru fiecare locație."
      }
    }
  ]
}`}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "image": "",
                      "@id": "",
                      "url": "",
                      "telephone": "0730 407 322",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4, 040213 București",
                        "addressLocality": "",
                        "postalCode": "",
                        "addressCountry": ""
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      }  
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <TestimonialsHome />
                <InformationHome />
                <ArticleContent />
            </Card>
        </>
    );
}

export default CuratenieGaleriiComerciale;
